import { render, staticRenderFns } from "./XFromLine.vue?vue&type=template&id=5127ba50&scoped=true"
import script from "./XFromLine.vue?vue&type=script&lang=js"
export * from "./XFromLine.vue?vue&type=script&lang=js"
import style0 from "./XFromLine.vue?vue&type=style&index=0&id=5127ba50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5127ba50",
  null
  
)

export default component.exports